module.exports = __webpack_public_path__ + "static/the-essential-rumi--reissue-5256d2ebcab7f5dc61711986d2a528c6.jpg";